import * as PropTypes from 'prop-types';
import * as React from 'react';
import MakeAnOffer from './make_an_offer';
import Negotiation from '../../negotiations/negotiation';
import { SanitizedRender, UserStore, APIRequest } from '@reverbdotcom/discovery-ui';
import UrlHelpers from '../../shared/url_helpers';
import * as ReactDOMServer from 'react-dom/server';

class Offers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      negotiation: {},
    };
  }

  componentDidMount() {
    if (this.isLoggedOut) { return; }

    APIRequest.V3.get(UrlHelpers.listingLatestNegotiationPath(this.props.productId)).then((resp) => {
      this.setState({
        isLoaded: true,
        negotiation: resp && new Negotiation(resp),
      });
    });
  }

  get isLoggedOut() {
    return UserStore.getState().loggedOut;
  }

  get hasNegotiation() {
    return !!this.negotiation.id;
  }

  get hasActiveNegotiation() {
    return this.hasNegotiation && this.negotiation.isActive;
  }

  get negotiation() {
    return this.state.negotiation;
  }

  get negotiationLink() {
    return `/my/buying/offers/${this.negotiation.id}?status=all`;
  }

  translate(key, args = {}) {
    return I18n.t(`digitalListing.makeAnOffer.${key}`, args);
  }

  renderStatus(content) {
    return (
      <p className="halfmargined-bottom">
        <SanitizedRender html={content} />
      </p>
    );
  }

  renderRejected() {
    if (this.negotiation.youLastInitiated) {
      return this.renderStatus(this.translate('lastOffer.rejected.you', {
        price: this.renderLastOfferPrice(),
        otherParty: this.negotiation.otherPartyName,
      }));
    }

    return this.renderStatus(this.translate('lastOffer.rejected.otherParty', {
      price: this.renderLastOfferPrice(),
    }));
  }

  renderCountered() {
    if (this.negotiation.youLastInitiated) {
      return this.renderStatus(this.translate('lastOffer.countered.you', {
        price: this.renderLastOfferPrice(),
      }));
    }

    return this.renderStatus(this.translate('lastOffer.countered.otherParty', {
      price: this.renderLastOfferPrice(),
      otherParty: this.negotiation.otherPartyName,
    }));
  }

  renderInitialOffer() {
    if (this.negotiation.youLastInitiated) {
      return this.renderStatus(this.translate('lastOffer.initialOffer.you', {
        price: this.renderLastOfferPrice(),
      }));
    }

    return this.renderStatus(this.translate('lastOffer.initialOffer.otherParty', {
      price: this.renderLastOfferPrice(),
    }));
  }

  renderLastOfferPrice() {
    return ReactDOMServer.renderToString(<strong>
      {this.negotiation.displayPrice}
    </strong>);
  }

  renderOfferActions() {
    if (!this.hasNegotiation) {
      return null;
    } if (this.negotiation.isActive && this.negotiation.youLastInitiated) {
      return (
        <a
          href={this.negotiationLink}
          className="button wide mt-half"
        >
          {this.translate('lastOffer.viewOffer')}
        </a>
      );
    } if (this.negotiation.isActive) {
      return (
        <a
          href={this.negotiationLink}
          className="button button--blue wide mt-half"
        >
          {this.translate('lastOffer.respond')}
        </a>
      );
    }

    return null;
  }

  renderOfferStatusContent() {
    if (!this.hasNegotiation) {
      return null;
    } if (this.negotiation.isRejected) {
      return this.renderRejected();
    } if (this.negotiation.isActive && this.negotiation.isCountered) {
      return this.renderCountered();
    } if (this.negotiation.isActive) {
      return this.renderInitialOffer();
    }

    return null;
  }

  renderOfferStatus() {
    const content = this.renderOfferStatusContent();

    if (!content) { return null; }

    return (
      <div className="halfmargined-top align-center">{content}</div>
    );
  }

  renderMakeOffer() {
    if (this.hasActiveNegotiation) { return null; }

    return (
      <MakeAnOffer
        productId={this.props.productId}
        productCurrency={this.props.productCurrency}
      />
    );
  }

  render() {
    if (this.isLoggedOut) { return this.renderMakeOffer(); }
    if (!this.state.isLoaded) { return null; }

    return (
      <div>
        {this.renderMakeOffer()}
        {this.renderOfferActions()}
        {this.renderOfferStatus()}
      </div>
    );
  }
}

Offers.propTypes = {
  productId: PropTypes.number.isRequired,
  productCurrency: PropTypes.string.isRequired,
};

export default Offers;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/show_page/offers.jsx